<template>
  <div class="task-manage-container">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="代理商类型">
        <a-select allowClear style="width: 100%" v-model="search.agentType">
          <a-select-option value="TTProxy">TTProxy</a-select-option>
          <a-select-option value="ProxyRack">ProxyRack</a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="部署类型">
        <a-select allowClear style="width: 100%" v-model="search.deployType">
          <a-select-option :value="0">国内</a-select-option>
          <a-select-option :value="1">新加坡</a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="状态">
        <a-select allowClear v-model="search.status" style="width: 100%">
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="-1">已停用</a-select-option>
          <a-select-option :value="0">未启用</a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点类型">
        <a-select allowClear v-model="search.spiderClassId" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.spiderClassId"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>
    <a-button class="add-btn" @click="openDialog" type="primary">新增IP池</a-button>

    <div class="table-container">
      <TableHeadIcons :onRefresh="getList" :size.sync="tableDensity" :columns="columns" />
      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :rowKey="(record) => record.spiderIpPoolId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, record">
          <a-button @click="editIppool(record)" type="link">修改</a-button>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm title="确定要删除吗?" @confirm="() => deleteIpPool(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm>
          <a-divider type="vertical"></a-divider>
          <a-button @click="showDetail(record)" type="link">详情</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="changeStatus(record)" type="link">{{
            record.status !== 1 ? '启用' : '停用'
          }}</a-button>
        </span>
      </a-table>
    </div>

    <a-modal :footer="null" title="IP池详情" :visible="detailFlag" @cancel="detailFlag = false">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <!-- <a-form-model-item label="IP代理池id">{{ detail.spiderIpPoolId }}</a-form-model-item> -->
        <a-form-model-item label="URL">{{ detail.url }}</a-form-model-item>
        <a-form-model-item label="站点类型">{{ detail.spiderClassName }}</a-form-model-item>
        <a-form-model-item label="部署类型">{{ detail.deployTypeName }}</a-form-model-item>
        <a-form-model-item label="代理商类型">{{ detail.agentTypeName }}</a-form-model-item>
        <a-form-model-item label="访问方式">{{ detail.accessModeName }}</a-form-model-item>
        <a-form-model-item label="状态">{{ detail.statusName }}</a-form-model-item>
        <a-form-model-item label="创建时间">{{ detail.createTime }}</a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      :footer="null"
      :title="`IP池${form.spiderIpPoolId ? '编辑' : '新增'}`"
      v-model="addFlag"
      @cancel="handleCancle"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item prop="url" label="URL">
          <a-input v-model="form.url" />
        </a-form-model-item>

        <a-form-model-item prop="agentType" label="代理商类型">
          <a-radio-group v-model="form.agentType" @change="angentTypeChange">
            <a-radio value="TTProxy">TTProxy</a-radio>
            <a-radio value="ProxyRack">ProxyRack</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="访问方式" prop="accessMode" v-if="!showFw">
          <a-select v-model="form.accessMode">
            <a-select-option value="2">通用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="访问方式" prop="accessMode" v-if="showFw">
          <a-select v-model="form.accessMode">
            <a-select-option value="3">通用</a-select-option>
            <a-select-option value="4">dns解析加账号密码</a-select-option>
            <a-select-option value="5">账号密码</a-select-option>
            <a-select-option value="6">长时间链接</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item prop="spiderClassId" label="站点类型">
          <a-select v-model="form.spiderClassId">
            <a-select-option
              v-for="item in selectList"
              :key="item.spiderClassId"
              :value="item.spiderClassId"
            >
              {{ item.spiderClassName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item prop="deployType" label="部署类型">
          <a-radio-group v-model="form.deployType">
            <a-radio :value="0">国内</a-radio>
            <a-radio :value="1">新加坡</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <p style="text-align: right">
          <a-button type="primary" @click="onSubmit">提交</a-button>
          <a-button style="margin-left: 10px" @click="handleCancle">取消</a-button>
        </p>
      </a-form-model>
    </a-modal>

    <a-modal :footer="null" v-model="statusFlag" :afterClose="cancleReplace" title="IP池替换">
      <p>选择替换的IP池:</p>
      <a-select v-model="replaceIpPoolId" style="width: 100%">
        <a-select-option
          clearable
          v-for="item in replaceIpPoolList"
          :key="item.spiderIpPoolId"
          :value="item.spiderIpPoolId"
          >{{ item.url }}
        </a-select-option>
      </a-select>

      <p style="text-align: right; margin-top: 15px">
        <a-button type="primary" :disabled="!this.replaceIpPoolId" @click="onReplaceStatus">提交</a-button>
        <a-button style="margin-left: 10px" @click="cancleReplace">取消</a-button>
      </p>
    </a-modal>
  </div>
</template>

<script>
import {
  getIpPoolList,
  addIpPool,
  editIpPool,
  deleteIpPool,
  editIpPoolStatus
} from '@/api/System/IpPool'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  components: { TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      search: {
        deployType: undefined,
        agentType: undefined,
        status: undefined,
        spiderClassId: undefined
      },
      tableDensity: 'middle',
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      spiderClassOptions: [],
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: 'URL',
          dataIndex: 'url',
          align: 'center',
          show: true
        },
        {
          title: '代理商类型',
          dataIndex: 'agentTypeName',
          align: 'center',
          show: true,
          width: 120
        },
        {
          title: '访问方式',
          dataIndex: 'accessModeName',
          align: 'center',
          show: true,
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          align: 'center',
          show: true,
          width: 90
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center',
          show: true,
          width: 90
        },
        {
          title: '部署类型',
          dataIndex: 'deployTypeName',
          align: 'center',
          show: true,
          width: 90
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          show: true,
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'taskCreateTime' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 280,
          align: 'center'
        }
      ],
      loading: false,
      showFw: false,
      addFlag: false,
      selectList: [],
      form: {
        url: undefined,
        agentType: 'TTProxy',
        spiderClassId: undefined,
        deployType: undefined,
        accessMode: undefined
      },
      rules: {
        url: [{ required: true, message: 'URL不能为空', trigger: 'blur' }],
        agentType: [{ required: true, message: '代理商类型不能为空', trigger: 'change' }],
        spiderClassId: [{ required: true, message: '站点类型不能为空', trigger: 'change' }],
        deployType: [{ required: true, message: '部署类型不能为空', trigger: 'change' }],
        accessMode: [{ required: true, message: '访问方式不能为空', trigger: 'change' }]
      },
      detailFlag: false,
      detail: {},

      statusFlag: false,
      replaceIpPoolId: '',
      changeStatusItem: {},
      replaceIpPoolList: []
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    this.getList()
    this.querySpiderClassInfo()
  },
  methods: {
    cancleReplace() {
      this.statusFlag = false
      this.replaceIpPoolId=undefined
    },
    angentTypeChange(value) {
      this.form.accessMode = ''
      if (value.target.value === 'ProxyRack') {
        this.showFw = true
      } else {
        this.showFw = false
      }
    },
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    showDetail(item) {
      this.detail = item
      this.detailFlag = true
    },
    handleCancle() {
      this.form = {
        url: undefined,
        agentType: 'TTProxy',
        spiderClassId: undefined,
        deployType: undefined,
        accessMode: undefined
      }
      this.addFlag = false
    },
    openDialog() {
      this.addFlag = true
      if (this.selectList.length === 0) {
        this.querySpiderClassInfoApi()
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.spiderIpPoolId) {
            //这里是编辑
            editIpPool(this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('编辑成功')
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.handleCancle()
              })
          } else {
            // 这里是新增
            addIpPool(this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('新增成功')
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.handleCancle()
              })
          }
        } else {
          this.$message.error('请完善表单')
          return false
        }
      })
    },

    editIppool(item) {
      this.form = {
        ...this.form,
        ...item
      }
      this.openDialog()
    },
    async querySpiderClassInfoApi() {
      const { code, data } = await querySpiderClassInfoApi()
      if (code === 200) {
        this.selectList = data
      }
    },
    async getList() {
      this.loading = true
      let { code, data, extra } = await getIpPoolList({
        ...this.search,
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      this.loading = false
      if (code === 200) {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },

    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },

    reset() {
      this.search.agentType = ''
      this.search.deployType = ''
      this.search.status = ''
      this.search.spiderClassId = ''
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.getList()
    },

    deleteIpPool(item) {
      deleteIpPool({ spiderIpPoolId: item.spiderIpPoolId }).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onReplaceStatus() {
      editIpPoolStatus({
        spiderIpPoolId: this.changeStatusItem.spiderIpPoolId,
        status: -1,
        replaceIpPoolId: this.replaceIpPoolId
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('替换成功')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.replaceIpPoolId = ''
          this.statusFlag = false
        })
    },
    async changeStatus(record) {
      // 1未启用状态
      if (record.status !== 1) {
        this.$confirm({
          title: '确认开启',
          content: '确认启用此IP池?',
          autoFocusButton: 'ok',
          okText: '确定',
          onOk: () => {
            editIpPoolStatus({ spiderIpPoolId: record.spiderIpPoolId, status: 1 }).then((res) => {
              if (res.code === 200) {
                this.$message.success('启用成功')
                this.getList()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else {
        this.changeStatusItem = record
        const { code, data } = await getIpPoolList()
        if (code === 200) {
          this.replaceIpPoolList = data.filter((item) => {
            return (
              record.spiderIpPoolId !== item.spiderIpPoolId &&
              record.spiderClassId === item.spiderClassId &&
              record.deployType === item.deployType
            )
          })
        }
        this.statusFlag = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.task-manage-container {
  width: 100%;
  padding: 16px;
  position: relative;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
  .add-btn {
    position: absolute;
    right: 180px;
    top: 32px;
  }
}
</style>
